import { addMethod, Schema as YupSchema, ObjectSchemaConstructor } from 'yup'

declare module 'yup' {
	export interface ObjectSchema<T extends object | null | undefined = object> extends YupSchema<T> {
		minProperties(minProperties: number): this
		maxProperties(maxProperties: number): this
	}
}

export function enrich(object: ObjectSchemaConstructor) {
	addMethod(object, 'minProperties', function (minProperties) {
		return this.test(
			'min-properties',
			`Object in path: \${path} does not satisfy minimum number of properties: ${minProperties}`,
			(schema) => {
				const properties = schema ? Object.keys(schema).length : 0
				return properties >= minProperties
			}
		)
	})

	addMethod(object, 'maxProperties', function (maxProperties) {
		return this.test(
			'max-properties',
			`Object in path: \${path} does not satisfy maximum number of properties: ${maxProperties}`,
			(schema) => {
				const properties = schema ? Object.keys(schema).length : 0
				return properties <= maxProperties
			}
		)
	})
}
